import { SvgIconProps } from "@mui/material/SvgIcon"

import { BsStarHalf, BsStarFill, BsStar } from "react-icons/bs"

const RatingStars = ({ rating, maxRating = 5, fontSize = "inherit" }: Props) => {
	return (
		<div>
			{Array.from(Array(maxRating).keys()).map((i) => {
				const isHalfFilled = rating >= i + 0.5
				const isFilled = rating >= i + 1

				const key = `${i}-${rating}-${maxRating}`

				if (isFilled) return <BsStarFill size="1.2rem" key={key} fontSize={fontSize} />

				return isHalfFilled ? (
					<BsStarHalf size="1.2rem" key={key} fontSize={fontSize} />
				) : (
					<BsStar size="1.2rem" key={key} fontSize={fontSize} />
				)
			})}
		</div>
	)
}

interface Props {
	rating: number
	maxRating?: number
	fontSize?: SvgIconProps["fontSize"]
}

export default RatingStars
